'use client';

import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

import { readRefParam } from '@/lib/ref-param';

const AffiliateContext = createContext<{ enabled: boolean; refCode: string | null }>({ enabled: false, refCode: null });

export function AffiliateProvider({ enabled, children }: { enabled: boolean; children: ReactNode }) {
    const [refCode, setRefCode] = useState<string | null>(null);
    useEffect(() => {
        // Read after mount: window is unavailable during SSR and useSearchParams would de-opt static pages.
        // eslint-disable-next-line react-hooks/set-state-in-effect
        if (enabled) setRefCode(readRefParam(window.location.search));
    }, [enabled]);
    return <AffiliateContext.Provider value={{ enabled, refCode }}>{children}</AffiliateContext.Provider>;
}

export const useAffiliate = () => useContext(AffiliateContext);
